import React from 'react';
import CardWithHeader from 'components/base/card-with-header';

type VendorDetailsType = {
  icon: JSX.Element;
  label: string;
  value: string;
};
const VendorDetails = ({ list }: { list: VendorDetailsType[] }) => {
  return (
    <CardWithHeader title='Vendor details'>
      {list.map(({ icon, label, value }, i) => (
        <div
          key={i}
          className={`py-2 flex items-center gap-4 ${
            i !== list?.length - 1 ? 'border-b border-gray-13' : ''
          }`}>
          <div className='w-[34px] h-[34px] text-red-5 rounded-full flex items-center justify-center p-[6px] border border-[#EFF0F0] my-1'>
            {icon}
          </div>
          <label className='grow text-sm text-gray-9'>{label}</label>
          <p className=''>{value}</p>
        </div>
      ))}
    </CardWithHeader>
  );
};

export default VendorDetails;
